import { ProductsSelections } from '../../../store/features/packages/types';

export function resetProductSingleIdsMap(
  productSingleIdsMap: ProductsSelections['productSingleIdsMap'],
) {
  return Object.fromEntries(
    Object.keys(productSingleIdsMap).map((key) => [key, '']),
  );
}
